import * as yup from 'yup';

import {
  ERROR_PASSWORD_MISMATCH,
  PASSWORD_MIN_LENGTH_REGEX,
  PASSWORD_NUMBER_REGEX,
  PASSWORD_SPECIAL_CHAR_REGEX,
  PASSWORD_UPPERCASE_REGEX,
  PASSWORD_LOWERCASE_REGEX,
} from '@/constants';

import { createNameofProxy } from '@/lib/ui';

import {
  ISetupPasswordPayload,
  PasswordRuleWithLabel,
  PasswordValidationRule,
} from '@/features/auth/interfaces';

export const PASSWORD_RULES: PasswordValidationRule[] = [
  { test: (value) => PASSWORD_MIN_LENGTH_REGEX.test(value) },
  { test: (value) => PASSWORD_UPPERCASE_REGEX.test(value) },
  { test: (value) => PASSWORD_LOWERCASE_REGEX.test(value) },
  { test: (value) => PASSWORD_NUMBER_REGEX.test(value) },
  { test: (value) => PASSWORD_SPECIAL_CHAR_REGEX.test(value) },
];

export const PASSWORD_RULES_WITH_LABELS: PasswordRuleWithLabel[] = [
  { label: '12 characters', test: (value) => PASSWORD_MIN_LENGTH_REGEX.test(value) },
  { label: 'Uppercase letter', test: (value) => PASSWORD_UPPERCASE_REGEX.test(value) },
  { label: 'Lowercase letter', test: (value) => PASSWORD_LOWERCASE_REGEX.test(value) },
  { label: 'Number', test: (value) => PASSWORD_NUMBER_REGEX.test(value) },
  {
    label: 'Special character ! @ # $ % ^ & * ( ) - _ + =',
    test: (value) => PASSWORD_SPECIAL_CHAR_REGEX.test(value),
  },
];

export const SETUP_PASSWORD_SCHEMA = yup.object().shape({
  password: yup.string().trim().required('New password is required.'),
  confirmPassword: yup
    .string()
    .trim()
    .required('Confirm password is required.')
    .oneOf([yup.ref('password')], ERROR_PASSWORD_MISMATCH),
}) as yup.ObjectSchema<ISetupPasswordPayload>;

export const SETUP_PASSWORD_FORM_FIELDS = createNameofProxy<ISetupPasswordPayload>();
